import Router from 'vue-router';
import Vue from 'vue';
// import config from '@/config'
Vue.use(Router)
const vueRouter = new Router({
  base: process.env.VUE_APP_PATH,
  mode: process.env.VUE_APP_MODE,
  routes: [{
    path: '/',
    component: () => import( /* webpackChunkName: "page" */ '@/page/index'),
    children: [
      { 
        path: '', 
        component: () => import( /* webpackChunkName: "page" */ '@/page/list'),
        meta: { title: '大屏管理'}
      },
      {
        path: 'category',
        component: () => import( /* webpackChunkName: "page" */ '@/page/list/category'),
        meta: { title: '分类管理'}
      }, {
        path: 'db',
        component: () => import( /* webpackChunkName: "page" */ '@/page/list/db'),
        meta: { title: '数据源管理'}
      }, {
        path: 'map',
        component: () => import( /* webpackChunkName: "page" */ '@/page/list/map'),
        meta: { title: '地图管理'}
      }, {
        path: 'document',
        component: () => import( /* webpackChunkName: "page" */ '@/page/list/document'),
        meta: { title: '分类管理'}
      }, {
        path: 'components',
        component: () => import( /* webpackChunkName: "page" */ '@/page/list/components'),
        meta: { title: '组件库'}

      }, {
        path: 'record',
        component: () => import( /* webpackChunkName: "page" */ '@/page/list/record'),
        meta: { title: '分类管理'}
      },
      {
        path: 'templetManage',
        component: () => import( /* webpackChunkName: "page" */ '@/page/templetManage'),
        meta: { title: '模板列表'}
      },
      {
        path: 'modelManage',
        component: () => import( /* webpackChunkName: "page" */ '@/page/modelManage'),
        meta: { title: '模型管理'}
      },
      {
        path: '/system',
        name: 'system',
        component: () => import( /* webpackChunkName: "page" */ '@/page/system/index'),
        redirect: 'system/user',//页面默认加载的路由
        children: [
          {
            path:'/system/user',
            name: '/system/user',
            component: () => import('@/page/system/user/index.vue'),
            meta: { title: '用户管理'},
          },
          {
            path:'/system/role',
            name: 'role',
            component: () => import('@/page/system/role/index.vue'),
            meta: { title: '角色管理'},
          },
          {
            path: '/system/menu',
            name: 'menu',
            component: () => import('@/page/system/menu/index.vue'),
            meta: { title: '菜单管理'},
          },
        ]
      },
    ]
  }, {
    path: '/create',
    name: 'create',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/create')
  }, {
    path: '/build/:id',
    name: 'build',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/build')
  }, {
    path: '/view/:id',
    name: 'view',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/view')
  },
  {

      path: '/manage',
      name: 'manage',
      component: () => import( /* webpackChunkName: "page" */ '@/page/manage/userClient')
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/system/login')
  },
  {
    path: '/sso/index',
    name: 'sso_index',
    component: () =>
      import( /* webpackChunkName: "page" */ '@/page/sso/index')
  }
]
})

vueRouter.beforeEach((to, from, next) => {
//   if (config.cas == 1) {
//     let token = sessionStorage.getItem('daping_token')
//     let jumpPath=['/sso/index']
//     if(to.path === '/login') {
//         window.location.href = config.baseUrl
//         return
//     }
//     if(token) {
//         next()
//     } else if (!token) {
//         if (jumpPath.includes(to.path)) {
//             next()
//         } else {
//             window.location.href = config.baseUrl
//         }
//     }
// } else {
    if(to.path === '/login') {
        next()
    } else {
      let token = localStorage.getItem("daping_token")
        if (token) {
            next()
        } else {
            next('/login')
        }
    }
// }

})
export default vueRouter;